import React from 'react';
import PropTypes from 'prop-types';
import './Message.scss';

const Message = ({ messages }) => (
  <div className="message-container">
    <div className="message-text">
      {
        !!messages && messages.length > 0 && messages.map((message, index) => <div key={index} className="message">{message}</div>)
      }
    </div>
  </div>
);

Message.propTypes = {
  messages: PropTypes.array.isRequired,
};

export default Message;
